import React from "react";

// TODO: Improve handling of colors in svg icons
interface Props {
  color?: string;
}

export const ToolbarIcon: React.FC<React.PropsWithChildren<Props>> = ({
  color,
}) => {
  return (
    <svg x="0" y="0" width="24" height="24" viewBox={`0 0 24 24`} fill={color}>
      <circle cx="12.5" cy="2.5" r="2.5" />
      <circle cx="12.5" cy="10" r="2.5" />
      <circle cx="12.5" cy="17.5" r="2.5" />
    </svg>
  );
};
